// Commented early code just in case

import { Toast, Tooltip } from './_bootstrap';

// (function () {
// 	// * Tooltip initialization, remove it if not necessary
// 	document
// 		.querySelectorAll('[data-toggle="tooltip"]')
// 		.forEach((tooltipElement) => new Tooltip(tooltipElement));

// 	// * Toast initialization, remove it if not necessary
// 	document
// 		.querySelectorAll('.toast')
// 		.forEach((toastElement) => new Toast(toastElement));
// })();
window.addEventListener("DOMContentLoaded", () => {
  // Document elements
  const heroSection = document.querySelector(
    "#hero-section, #landing_hero-section"
  );
  const firstSection = document.querySelector("section:first-of-type");

  const header = document.getElementById("header");
  const footer = document.getElementById("footer");

  const navbar = document.querySelector("#navbar");
  const languageSwitch = document.querySelector("#language-switch");
  const dropdownToggles = document.querySelectorAll(
    ".navbar .dropdown-toggle, .navbar .navbar-toggler"
  );
  const dropdownToggle = document.querySelector("img.dropdown-toggle.flag");
  const dropdownMenu = document.querySelector(
    "div.dropdown-menu.language-switch"
  );
  const backToTopBtn = document.querySelector("#btn-back-to-top");

  const animatedSection = document.querySelector("section.animated-section");

  const lineContainers = document.querySelectorAll(".line-container");

  const fork = document.querySelector(".fork");

  const dates = document.querySelectorAll(".date");

  const brands = document.querySelectorAll("section.brands");

  const textContainer = document.querySelector('.container-with-one-image div');
  const imageInContainer = document.querySelector('.container-with-one-image img');


  // const circleSections = document.querySelectorAll(
  //   "section.circle-component-right:not(.blog), section.circle-component-left:not(.blog)"
  // );


  // Function to transform language switcher
  const dropdownToFlex = () => {
    if (window.innerWidth < 1200) {
      // Remove Dropdown classes
      languageSwitch.classList.remove("dropdown");
      dropdownToggle.classList.remove("dropdown-toggle");
      dropdownMenu.classList.remove("dropdown-menu");

      // Remove flex classes from nav
      navbar.classList.remove("d-flex");
      navbar.classList.remove("flex-row");
      navbar.classList.remove("flex-nowrap");

      // Add flex classes
      languageSwitch.classList.add("d-flex");
      languageSwitch.classList.add("flex-row");
      languageSwitch.classList.add("align-items-center");
      dropdownMenu.classList.add("d-flex");
      dropdownMenu.classList.add("flex-row");
      dropdownMenu.classList.add("align-items-center");
      dropdownMenu.classList.add("justify-content-between");
    } else {
      // Remove flex classes
      languageSwitch.classList.remove("d-flex");
      languageSwitch.classList.remove("flex-row");
      languageSwitch.classList.remove("align-items-center");
      dropdownMenu.classList.remove("d-flex");
      dropdownMenu.classList.remove("flex-row");
      dropdownMenu.classList.remove("align-items-center");
      dropdownMenu.classList.remove("justify-content-between");

      // Add Dropdown classes
      languageSwitch.classList.add("dropdown");
      dropdownToggle.classList.add("dropdown-toggle");
      dropdownMenu.classList.add("dropdown-menu");

      // Add flex classes from nav
      navbar.classList.add("d-flex");
      navbar.classList.add("flex-row");
      navbar.classList.add("flex-nowrap");
    }
  };
  // Function to display BTT (back to top) button
  const showBackToTop = () => {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      backToTopBtn.style.display = "block";
    } else {
      backToTopBtn.style.display = "none";
    }
  };

  // Function to get BTT
  const backToTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  // Function to handle scroll event
  const handleScroll = () => {
    const openMenus = document.querySelectorAll(
      ".dropdown-menu.show, .navbar-collapse.show"
    );
    if (window.scrollY > 50 || openMenus.length > 0) {
      header.classList.add("header-scrolled");
    } else {
      header.classList.remove("header-scrolled");
    }
  };

  // Function to add margin top on pages with no hero section
  const setMarginTop = () => {
    if (window.matchMedia("(max-width: 767.98px)").matches) {
      firstSection.style.marginTop = "150px";
    } else if (window.matchMedia("(max-width: 1366px)").matches) {
      firstSection.style.marginTop = "200px";
    } else {
      firstSection.style.marginTop = "220px";
    }
  };


  // Function to display sections on click in history page
  const showTimelineSection = (_this) => {
    const section = _this.closest(".timeline").querySelector("section");
    const dateOuter = _this.closest(".date-outer");
    const dateContent = _this.closest(".date-content");

    if (section && dateOuter && dateContent) {
      // Toggle display of the clicked section
      section.style.display =
        section.style.display === "block" ? "none" : "block";

      // Hide other sections
      document.querySelectorAll(".timeline section").forEach((el) => {
        if (el !== section) {
          el.style.display = "none";
        }
      });

      // Remove the "highlight" class from all date outers
      document.querySelectorAll(".date-outer").forEach((content) => {
        content.classList.remove("highlight");
      });

      // Remove the "line" class from all date contents
      document.querySelectorAll(".date-content").forEach((content) => {
        content.classList.remove("line");
      });

      // Add the "line" and "highlight" classes to the clicked date's content if the section is displayed
      if (section.style.display === "block") {
        dateContent.classList.add("line");
        dateOuter.classList.add("highlight");
      }
    }
  };

  // Function to set "sm" class to circle components
  // function countCharactersInSection() {
  //   if (!circleSections) {
  //     return;
  //   }

  //   circleSections.forEach((section) => {
  //     const text = section.textContent;
  //     const characterCount = text.length;

  //     if (characterCount < 1200) {
  //       section.classList.add("sm");
  //     }
  //   });
  // }

  // Scale image to text container (container-with-one-image component)
  function scaleImageToTextContainer() {
    if (textContainer && imageInContainer && window.innerWidth > 768) {
      const textHeight = textContainer.offsetHeight;
      imageInContainer.style.maxHeight = `${textHeight}px`;
    }
  }
  /* ================================================
        ? Animation Logic (Landing & Familie...)
     =================================================*/
  // Elements will slide in as they reach scroll view
  function slideInOnScroll() {
    const elements = [...lineContainers];
    function showElements() {
      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const isInView =
          rect.top >= 0 &&
          rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight);

        if (isInView) {
          element.classList.add("slide-in"); // Add class for sliding animation when the element is in view
        } else {
          element.classList.remove("slide-in"); // Remove class when the element is not in view
        }
      });
    }

    function showFork() {
      const rect = fork.getBoundingClientRect();
      const isInView = rect.top <= window.innerHeight && rect.bottom >= 0;

      if (isInView) {
        fork.classList.add("slide-in"); // Add class for sliding animation when the element enters the viewport
      } else {
        fork.classList.remove("slide-in"); // Remove class when the fork is not in view
      }
    }
    // Initial check on page load
    showElements();
    showFork();

    // Attach the scroll event listener
    window.addEventListener("scroll", () => {
      showElements();
      showFork();
    });
  }

  /* ================================================
        ? Hover on Scroll Logic (Brands page)
     =================================================*/
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("hovered"); // Add 'hovered' class
        } else {
          entry.target.classList.remove("hovered"); // Remove 'hovered' class
        }
      });
    },
    { root: null, threshold: 0.35 }
  );

  function hoverOnScroll() {
    brands.forEach((brandsSection) => {
      const brandCols = brandsSection.querySelectorAll(".brand.col");

      // Check the screen width and add/remove 'mobile' class
      if (window.innerWidth < 1366) {
        brandsSection.classList.add("mobile");
      } else {
        brandsSection.classList.remove("mobile");
      }

      // Intersection Observer for each section
      brandCols.forEach((brandCol) => {
        if (brandsSection.classList.contains("mobile")) {
          observer.observe(brandCol);
        } else {
          observer.unobserve(brandCol);
          brandCol.classList.remove("hovered");
        }
      });
    });
  }

  /* ================================================
        ? Event listeners
     =================================================*/
  // Language switcher not a dropdown on small screens
  dropdownToFlex();

  // countCharactersInSection();

  if (heroSection) {
    handleScroll();
  } else setMarginTop();
  window.addEventListener("resize", () => {
    dropdownToFlex();
    if (!heroSection) setMarginTop();
    scaleImageToTextContainer()
  });

  // Change header background color on scroll
  window.addEventListener("scroll", () => {
    showBackToTop();
    if (heroSection) handleScroll();
    if (animatedSection) slideInOnScroll();
  });

  // When the user clicks on the button, scroll to the top of the document
  backToTopBtn.addEventListener("click", backToTop);

  // Header gains background color when dropdown is open
  dropdownToggles.forEach((dropdownToggle) => {
    dropdownToggle.addEventListener("click", () => {
      setTimeout(() => {
        if (heroSection) handleScroll();
      }, 400);
    });
  });

  // If no dropdowns are active, check scroll state to set header background color
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".navbar .dropdown")) {
      setTimeout(() => {
        if (heroSection) handleScroll();
      }, 100);
    }
  });

  // Check if animated section is already in view
  if (animatedSection) {
    slideInOnScroll();
  }

  if (brands) {
    hoverOnScroll();
  }

  if (dates) {
    dates.forEach((date) => {
      date.addEventListener("click", function () {
        showTimelineSection(this);
      });
    });
  }
});
